module.exports = __webpack_public_path__ + "static/CalibreWeb-Semibold-87a85234fa252fa8fea58d358605a40a.woff2";